import type { QueryClient } from '@tanstack/react-query'

/**
 * Zentrale Invalidierungs-Gruppen (Audit „Widgets werden nicht geupdatet"):
 * Jede Mutation, die Zeitdaten ändert, muss ALLE Caches treffen, die daraus
 * rechnen — vorher invalidierte z.B. keine einzige Eintrag-/Abwesenheits-/
 * Meeting-Mutation die ['time-accounts'] (Urlaubskonto-Widget/Stundenkonto
 * blieben im selben Fenster stale) und Meeting-Mutationen gar nichts.
 *
 * Präfix-Matching von TanStack Query deckt alle Unter-Keys ab
 * (['reports'] trifft ['reports','weekly'], ['reports','range',…] usw.).
 */

/** Zeiteinträge geändert (create/update/delete/move/resize/split/copy/Timer). */
export function invalidateEntryData(qc: QueryClient): void {
  qc.invalidateQueries({ queryKey: ['entries'] })
  qc.invalidateQueries({ queryKey: ['reports'] })
  qc.invalidateQueries({ queryKey: ['time-accounts'] })
  // Kontingent (#511): Verbrauch, eigene Stunden und "zuletzt gebucht".
  qc.invalidateQueries({ queryKey: ['project-budget-status'] })
  qc.invalidateQueries({ queryKey: ['time-entries', 'last-selection'] })
}

/** Abwesenheiten geändert (Antrag/Genehmigung/Storno/Widerruf/Edit). */
export function invalidateAbsenceData(qc: QueryClient): void {
  qc.invalidateQueries({ queryKey: ['absences'] })
  qc.invalidateQueries({ queryKey: ['absence-status'] })
  qc.invalidateQueries({ queryKey: ['reports'] })
  qc.invalidateQueries({ queryKey: ['time-accounts'] })
  // Kontingent (#511): genehmigter Urlaub verändert die Restarbeitstage.
  qc.invalidateQueries({ queryKey: ['project-budget-status'] })
}

/** Meetings geändert (create/update/delete/RSVP/countsAsWork). */
export function invalidateMeetingData(qc: QueryClient): void {
  qc.invalidateQueries({ queryKey: ['meetings'] })
  qc.invalidateQueries({ queryKey: ['reports'] })
  qc.invalidateQueries({ queryKey: ['time-accounts'] })
}
